import React, { createContext } from "react";

export const PayeeContext = React.createContext();
